import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import AddressItem from '../../../../components/AddressItem';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import PageHeader from '../../../../components/PageHeader';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';
import RequestService from '../../../../services/RequestService';
import StorageService from '../../../../services/StorageService';
import TypesService from '../../../../services/TypesService';
import { sendSlice } from '../../../../store/slices';

import './SendAccount.scss';

const { routes } = AppConfig;

const BlockchainsById = TypesService.BlockchainsById;
const CurrenciesById = TypesService.CurrenciesById;

const SendAccount = () => {
	const [addresses, setAddresses] = useState([]);
	const [loading, setLoading] = useState(false);

	const asset = useSelector(state => state.send.asset || {});
	// const availableCurrencies = useSelector(store => store.app.availableCurrencies);

	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	// const [searchParams] = useSearchParams();
	// const currencyId = searchParams.get('currencyId');

	// const asset = availableCurrencies.find(({ Id }) => Id === Number(currencyId));

	const currencyData = CurrenciesById[asset.Id];
	const currencyBlockchainData = BlockchainsById[currencyData.BlockchainId];
	const sortedAddresses = [...addresses].sort((a, b) => b.AmountUsd - a.AmountUsd);

	const getAddresses = async () => {
		try {
			setLoading(true);
			const response = await RequestService.GetAddressesByCurrency(asset.Id);
			setLoading(false);
			if (response?.Status === 'Success') {
				setAddresses(response.Addresses);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		getAddresses();
		dispatch(sendSlice.actions.setAmount());
		StorageService.UpdateQuotes();
	}, []);

	const selectAddress = address => {
		dispatch(sendSlice.actions.setAccount(address));
		navigate(routes.sendRecipient, location);
		// navigate(
		// 	{
		// 		pathname: routes.sendRecipient,
		// 		search: createSearchParams({ currencyId: asset.Id, address: address.Address }).toString(),
		// 	},
		// 	location
		// );
	};

	return (
		<div className='SendAccount'>
			<PageHeader
				header={'Select address'}
				subheader={<>{currencyData.Name + ' ' + currencyBlockchainData.Name + ' ' + currencyData.Standart}</>}
				icon={currencyData.CompanyIcon}
				iconLabel={currencyData.CompanyIcon !== currencyBlockchainData.Icon ? currencyBlockchainData.Icon : null}
			/>
			<div className='SendAccount__body'>
				{loading || sortedAddresses.length ? (
					<div className='SendAccount__container FormBlock'>
						{sortedAddresses.map((address, index) => (
							<AddressItem
								key={index}
								address={address}
								lastItem={index === sortedAddresses.length - 1}
								onClick={selectAddress}
							/>
						))}
					</div>
				) : (
					<div className='SendAccount__empty-state'>
						<Icon type={Icons.EMPTY_ACCOUNT_LIST_ICON} width={240} height={124} />
						<div className='SendAccount__empty-header'>{t('No addresses yet')}</div>
						<div className='SendAccount__empty-text'>{t('Creating wallet addresses…')}</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default SendAccount;
